import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
const MyContext = createContext(null);

export const MyProvider = ({ children }) => {
  const value = React.useMemo(() => ({ future: 'Validar' }), []);
  return <MyContext.Provider value={value}>{children}</MyContext.Provider>;
};

MyProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useMyContext = () => {
  const context = useContext(MyContext);
  if (!context) {
    throw new Error('useMyContext must be used within a MyProvider');
  }
  return context;
};
